import React from "react"
import { cn } from "../utils"

export type NoteContentLeadingProps = {
  children: React.ReactNode
  className?: string
}

export function NoteContentLeading({
  children,
  className
}: NoteContentLeadingProps) {
  return (
    <div
      className={cn(
        "[grid-area:icon] flex items-center justify-center",
        className
      )}
      data-slot="note-content-leading"
    >
      {children}
    </div>
  )
}
